exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-tag[data-v-44db05b9]{margin:0 8px 8px 0}.button-new-tag[data-v-44db05b9]{height:32px;line-height:30px;padding-top:0;padding-bottom:0}.input-new-tag[data-v-44db05b9]{width:180px;vertical-align:top}.attributes-form[data-v-44db05b9] .el-form-item{margin-bottom:8px;padding:16px 0;border-top:1px solid var(--border)}.attributes-form[data-v-44db05b9] .el-form-item:first-child{border-top:none;padding-top:0}.attributes-form[data-v-44db05b9] .el-form-item__label{font-family:var(--font-heading);font-size:16px;font-weight:500}.attributes-form[data-v-44db05b9] .el-checkbox-group{display:grid;grid-template-columns:repeat(auto-fill,minmax(190px,1fr));gap:4px 16px}.attributes-form[data-v-44db05b9] .el-checkbox{margin-right:0;line-height:28px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44db05b9","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/locations/LocationAttributes.vue
// module id = 617
// module chunks = 0